import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import { Link } from 'react-router'

import OrderStore from '../../../stores/orders'

import OrderableTH from '../../navigation/OrderableTH'
import StorePagination from '../../navigation/StorePagination'

const statuses = {
  pending: 'Pending',
  complete: 'Complete',
  notify: 'Needs Notify',
}

@inject('auth')
@observer
export default class Orders extends Component {
  state = {
    order_by: 'created_at',
    order_dir: 'desc'
  }

  orders = new OrderStore()

  componentWillMount() {
    this.loadPage()
  }

  loadPage(nextPage) {
    const { page = 1 } = this.props.location.query
    this.orders.loadPage(nextPage || page, this.state)
  }

  componentWillReceiveProps(nextProps) {
    const { page: next, ...nextQuery } = nextProps.location.query
    const { page: prev, ...prevQuery } = this.props.location.query

    if (next !== prev) {
      this.loadPage(next)
    } else if (nextQuery.order_by !== prevQuery.order_by || nextQuery.order_dir !== prevQuery.order_dir) {
      this.setState(nextQuery, () => this.loadPage())
    }
  }

  isAdmin() {
    return this.props.auth.user.admin
  }

  resellerHeading() {
    if (!this.isAdmin()) return null
    return (
      <OrderableTH query={this.state} field="reseller_teams.name">Reseller</OrderableTH>
    )
  }

  resellerRow(order) {
    if (!this.isAdmin()) return null
    return (
      <td>{order.reseller_team_name}</td>
    )
  }

  pocName(order) {
    const { params } = order
    const agent_name = `${ params.agent_first_name || '' } ${params.agent_last_name || '' }`
    const dev_name = params.consultant_name
    return params.point_of_contact === 'dev' ? dev_name : agent_name
  }

  pocEmail(order) {
    const { params } = order
    const agent_email = params.agent_email
    const dev_email = params.consultant_email
    return params.point_of_contact === 'dev' ? dev_email : agent_email
  }

  pocPhone(order) {
    const { params } = order
    const agent_phone = params.agent_phone
    const dev_phone = params.consultant_phone
    const phone = params.point_of_contact === 'dev' ? dev_phone : agent_phone
    const formatPhone = (n='') => n.replace(/\D/g, '').replace(/(\d{3})(\d{3})(\d{4})/, (_,a,b,c) => `(${a}) ${b}-${c}`)
    return formatPhone(phone)
  }

  mlsList(order) {
    if (!order.params.mls_selected) return ''
    const active = order.params.mls_selected.filter(mls => mls.active)
    const ids = active.map(mls => mls.mls_id.toUpperCase())
    return ids.join(', ')
  }

  orderUrl(order) {
    if (order.status === 'complete' && order.team_id) {
      return `teams/${order.team_id}`
    } else {
      return `orders/${order.id}`
    }
  }

  render() {
    return (
      <div className="container padded teams">
        <div className="panel full padded">
          <h2 className="title">Orders <small>({this.orders.totalCount} total)</small></h2>

          <Link className="button" to="/orders/signup_code">Get Signup Form</Link>
          <br />
          <br />

          <table className="zebra">
            <thead>
              <tr>
                <th style={{textAlign: 'left'}}>#</th>
                <OrderableTH query={this.state} field="status">Status</OrderableTH>
                <th>Contact</th>
                <th>Contact Name</th>
                <th>Contact Email</th>
                <th>Contact Phone</th>
                <th>MLS</th>
                {this.resellerHeading()}
                <OrderableTH query={this.state} field="created_at">Created</OrderableTH>
              </tr>
            </thead>
            <tbody>
              {this.orders.map((o,i) => (
                <tr key={o.id}>
                  <td><small>{this.orders.perPage * (this.orders.currentPage - 1) + i + 1}</small></td>
                  <td><Link to={this.orderUrl(o)}>{statuses[o.status]}</Link></td>
                  <td><Link to={this.orderUrl(o)}>{o.params.point_of_contact || 'agent'}</Link></td>
                  <td>{this.pocName(o)}</td>
                  <td>{this.pocEmail(o)}</td>
                  <td>{this.pocPhone(o)}</td>
                  <td>{this.mlsList(o)}</td>
                  {this.resellerRow(o)}
                  <td>{new Date(o.created_at).toDateString()}</td>
                </tr>
              ))}
            </tbody>
          </table>

          <StorePagination store={this.orders} query={this.state} />
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// client/components/sections/Orders/index.js